export default "__VITE_ASSET__BR3fo6Nb__"